import kr from 'Kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class HomeOpinionSlider extends kr.Component {
    init() {
        this.slider = new Swiper(this.$element.querySelector('.js--homeopinion-swiper'), {
            loop: true,
            autoplay: {
                delay: 7000,
            },
            navigation: {
                nextEl: this.$element.querySelector('.js--homeopinion-swiper-nav-next'),
                prevEl: this.$element.querySelector('.js--homeopinion-swiper-nav-prev')
            },
            pagination: {
                el: '.js--homeopinion-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            slidesPerView: 1.2,
            centeredSlides: true,
            spaceBetween: 12,
            breakpoints: {
                993: {
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 0
                }
            }
        });
        this.tags = this.$element.querySelectorAll('.js--homeopinion-tags [data-slide-tags]');
        this._event();
    }

    _event() {
        this.slider.on('slideChange', (event) => {
            const slide = this.slider.slides[event.activeIndex];
            this._changeTags(slide.getAttribute('data-slide'));
        });
    }

    _changeTags(name) {
        for (let tag of this.tags) {
            const names = tag.getAttribute('data-slide-tags');
            if (names.includes(name)) {
                HTMLClass.addClass(tag, 'active');
            } else {
                HTMLClass.removeClass(tag, 'active');
            }
        }
    }
}

kr.registerComponent('.js--homeopinion', {
    component: HomeOpinionSlider
});
